'use strict';
angular.module('reporting.dashboards')
    .factory('i18nPartialLoaderErrorHandler', ['$q', function ($q) {
        return function () {
            // log missing language file
            return $q.when({});
        };
    }]);
